































































import Vue from 'vue'
import bus from '../model/bus'

export default Vue.extend({
    name: 'Loot',
    data() {
        return {
            bus,
            manager: bus.loot.ItemSetManager,
            set: null,
        }
    },
    created() {},
    computed: {},
    methods: {
        add(set) {
            try {
                this.manager.add(set)
            } catch (error) {
                this.$bvToast.toast(`${set.label} already exists!`, { title: 'Error', variant: 'danger', solid: true })
            }
        },
        remove(set) {
            if (confirm('Are you sure?')) {
                this.manager.remove(set)
            }
        },
        setWeight() {
            const value = prompt('Please input the Weight', '1')
            if (value !== null) {
                this.manager.list.forEach(item => {
                    item.SetWeight = parseInt(value)
                })
            }
        },
        show(set) {
            this.set = set
            this.$bvModal.show('item-modal')
        },
    },
})
